import moment from 'moment'

function formatDate(date, format) {
  // if (!(date instanceof Date)) {
  //   date = new Date(date)
  // }
  return moment(date).format(format || 'MMMM Do, YYYY')
}

export default formatDate



// WEBPACK FOOTER //
// ./src/utils/formatDate.js